module.exports = __webpack_public_path__ + "mainBtn.1599fd73.png";